module.exports = __webpack_public_path__ + "static/media/bottom@2x.488991ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/new-sticker-media-audio/img/bottom@2x.png
// module id = 1336
// module chunks = 0